import React, { ReactNode } from 'react';

export default function PageContainer({ children }: { children: ReactNode }) {
    return (
        <div className="mx-auto flex flex-col" style={{ maxWidth: '70rem' }}>
            <div className="w-full flex-grow py-4 px-5 mx-auto bg-white">{children}</div>
        </div>
    );
}
